module.exports = "/assets/footer/rewards/e-gazele.png?p+pt4Bk";